import React from 'react';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { FormattedMessage } from '@atlassian/jira-intl';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	MODAL,
} from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

type WarningContentProps = {
	isEmailEnabled: boolean | undefined;
	canUserEnableEmail: boolean;
	isUserHIPAA: boolean;
};

export function WarningContent({
	isEmailEnabled,
	canUserEnableEmail,
	isUserHIPAA,
}: WarningContentProps) {
	if (isEmailEnabled === false || isUserHIPAA) {
		return (
			<ContextualAnalyticsData sourceType={MODAL} sourceName="PreShareWarningView">
				<WarningIcon
					LEGACY_size="medium"
					spacing="spacious"
					label="Warning"
					testId="share-button.ui.pre-share-view.warning-content.warning-icon"
				/>
				{isEmailEnabled === false && (
					// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
					<p>
						<FormattedMessage {...messages.disabledWarningMessage} /> <br />
						{canUserEnableEmail ? (
							<>
								<FormattedMessage {...messages.adminEnableOutgoingMail} />{' '}
								<Link href="/secure/admin/OutgoingMailServers.jspa">
									<FormattedMessage {...messages.outgoingMail} />
								</Link>
							</>
						) : (
							<FormattedMessage {...messages.nonAdminWarningMessage} />
						)}
					</p>
				)}
				{isEmailEnabled !== false && (
					<FormattedMessage
						{...(fg('jira-issue-terminology-refresh-m3')
							? messages.disabledWarningMessageIfHipaaIssueTermRefresh
							: messages.disabledWarningMessageIfHipaa)}
					/>
				)}
				<FireScreenAnalytics
					attributes={{
						canUserEnableEmail,
						isUserHIPAA,
					}}
				/>
			</ContextualAnalyticsData>
		);
	}

	return null;
}
